import React, { useCallback, useRef } from 'react';
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withTiming,
} from 'react-native-reanimated';
import { GoogleAdsView } from 'native-views';
import { StyleSheet } from 'react-native';
import { useScreenSize } from '@banhala/ui-kit';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

interface Props {
  refreshKey: string;
  onError?: () => void;
}

export const GoogleAdsAnimated = ({ refreshKey, onError }: Props) => {
  const { width } = useScreenSize();
  const height = useSharedValue(0);
  const didAnimateOnce = useRef(false);
  const logAnalyticsEvent = useLogAnalyticsEvent();

  const expand = useCallback(() => {
    if (!didAnimateOnce.current) {
      didAnimateOnce.current = true;
      height.value = withTiming(48, { duration: 250 });
    }
  }, [height]);

  const animatedStyle = useAnimatedStyle(() => ({
    height: height.value,
  }));

  return (
    <Animated.View style={[styles.container, animatedStyle]}>
      <GoogleAdsView
        refreshKey={refreshKey}
        onRequest={() => {
          logAnalyticsEvent({
            name: 'CALL_ADS',
            channel: ['firebase', 'ablylog'],
            analytics: {
              ADVERTISING_SUPPLIER: 'GOOGLE',
            },
          });
        }}
        onLoad={() => {
          expand();
          logAnalyticsEvent({
            name: 'LOAD_ADS',
            channel: ['firebase', 'ablylog'],
            analytics: {
              ADVERTISING_SUPPLIER: 'GOOGLE',
            },
          });
          logAnalyticsEvent({
            name: 'DISPLAY_ADS',
            channel: ['firebase', 'ablylog'],
            analytics: {
              ADVERTISING_SUPPLIER: 'GOOGLE',
            },
          });
        }}
        onError={event => {
          logAnalyticsEvent({
            name: 'FAIL_ADS',
            channel: ['firebase', 'ablylog'],
            analytics: {
              ADVERTISING_SUPPLIER: 'GOOGLE',
              ERROR_CODE: event.nativeEvent.code,
              ERROR_MESSAGE: event.nativeEvent.description,
            },
          });
          onError?.();
        }}
        // onDisplay는 GAD impression 콜백이나, 이벤트가 씹히는 이슈로
        // DISPLAY_ADS 로깅을 onLoad에서 함께 처리 (Android 리뷰 합의)
        onDisplay={() => {}}
        onTap={() => {
          logAnalyticsEvent({
            name: 'CLICK_ADS',
            channel: ['firebase', 'ablylog'],
            analytics: {
              ADVERTISING_SUPPLIER: 'GOOGLE',
            },
          });
        }}
        style={{ width, height: 48 }}
      />
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
  },
});
